import * as React from 'react';
import { Button } from '@cian/button-component';
import { trackSafeRentShow } from '../../store/deal-rent/tracking';
import * as styles from './index.css';

export interface IDealRentButtonProps {
  isAvailable: boolean;
  isLoading: boolean;
  buttonTitle: string;
  open(): void;
}

export const DealRentButton = ({ open, isAvailable, isLoading, buttonTitle }: IDealRentButtonProps) => {
  React.useEffect(() => {
    if (isAvailable) {
      trackSafeRentShow();
    }
  }, [isAvailable]);

  return isAvailable ? (
    <div className={styles['container']}>
      <Button onClick={open} theme="ghost" isSync={isLoading}>
        {buttonTitle}
      </Button>
    </div>
  ) : null;
};
